
import { IRegister } from '@/interfaces'
import NetworkService, { Endpoint } from './NetworkService'

export default class UserService extends NetworkService {
    constructor() {
        super()
    }

    show = (id: string) => {
        return this.get(`${Endpoint.users}/${id}`)
    }
    create = async (params: IRegister) => {
        const res = await this.post(Endpoint.users, params)
    }
}